import { render, staticRenderFns } from "./gas.vue?vue&type=template&id=08f6154b&scoped=true&"
import script from "./gas.vue?vue&type=script&lang=js&"
export * from "./gas.vue?vue&type=script&lang=js&"
import style0 from "./gas.vue?vue&type=style&index=0&id=08f6154b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6154b",
  null
  
)

export default component.exports